import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui-kit/select';
import { StatusBadge } from './status-badge';

interface StatusOption {
  value: string;
  /** Existing UILM key for the option label. */
  labelKey: string;
}

interface StatusSelectCellProps {
  status: string;
  options: StatusOption[];
  /** True once a status is final (e.g. `Delivered`) or the viewer may not change it. */
  locked: boolean;
  /** While a change is being saved, so a second pick cannot race it. */
  disabled?: boolean;
  onChange: (status: string) => void;
}

/**
 * The inline status selector of the fulfilment pipelines (Business Card, ID Card, MetLife). When
 * the status cannot be changed it degrades to the plain badge.
 */
export const StatusSelectCell = ({
  status,
  options,
  locked,
  disabled = false,
  onChange,
}: StatusSelectCellProps) => {
  const { t } = useTranslation();

  if (locked) return <StatusBadge status={status} />;

  return (
    <Select
      value={status}
      disabled={disabled}
      onValueChange={(next) => next !== status && onChange(next)}
    >
      <SelectTrigger className="h-8 w-36" onClick={(event) => event.stopPropagation()}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {t(option.labelKey)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
